import React from 'react'

export const DisplayField = ({
  title,
  value,
  className,
  hideNulls = false,
  ...otherProps
}) =>
  hideNulls && !value ? null : (
    <div
      className={`DisplayField ${className ? className : ''}`}
      {...otherProps}
    >
      <div className='title'>{title}</div>
      <div className='value'>{value}</div>
    </div>
  )

export default DisplayField
